/* globals Class, $H */
window.jui.ColorPickerButton = Class.create(window.jui.Component, window.jui.ControlModel, {
  options: function($super,options){
    return $super($H({attributes:{className:'color-picker-button'}}).merge(options));
  },

  initialize: function($super, options) {
    $super(options );
    window.jui.ColorPickerButton.colorPickerDialog = window.jui.ColorPickerButton.colorPickerDialog || new window.jui.ColorPickerDialog();


    if (this.options.action) {
      this.addListener('actionPerformed', this.options.action);
    }
  },

  installUI: function($super) {
    $super();
    this.swatch = this.insert(new Element('div', {className:'swatch color-picker-swatch'}));
    this.e.observe('click', this.onClick.bindAsEventListener(this));
  },

  setColor: function(hex) {
    this.swatch.style.backgroundColor = hex && hex.length > 2 ? '#'+hex : '';
  },

  getColor: function(text) {
    /* jshint unused:vars */
    return this.toValidHexColor(this.swatch.style.backgroundColor);
  },

  colorPicked: function(hex) {
    this.setColor(hex);
    this.fireEvent( 'actionPerformed', this.getColor());
  },

  toValidHexColor: function(value) {
    if (value.startsWith('#')) {
      return value.sub('#', '');
    } else if (value.startsWith('rgb')) {
      // WTF? TODO replace this
      return eval(value.sub('rgb(', '[').sub(')', ']')).invoke('toColorPart').join(''); // jshint ignore:line
    } else {
      return value;
    }
  },

  onClick: function(e) {
    if(this.isEnabled()) {
      e.stop();
      window.jui.ColorPickerButton.colorPickerDialog.open(this.getColor(), {callback:this.colorPicked.bind(this)});
    }
  }
});

window.jui.ColorPickerButton.colorPickerDialog = null;



//////////////////
// WEBPACK FOOTER
// ./src/legacy/jui/color_picker_button.js
// module id = 278
// module chunks = 0 1